export const StatusEnum = {
  Deleted: '0',
  Free: '2',
  Reduced: '3',
  Paid: '4',
  Withdrawn: '5',
  Teacher: '6',
  Adult: '7',
  SchoolFoodService: '8',
  Catering: '9',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/StatusEnum.js